(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-single-addtocart"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('.product-form__cart-submit').forEach(function(btn) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName !== 'class') return;
          var wasLoading = mutation.oldValue && mutation.oldValue.indexOf('loading') !== -1;
          var isLoading = btn.classList.contains('loading');
          if (wasLoading && !isLoading) {
            var textEl = btn.querySelector('#AddToCartText') || btn.querySelector('.add-to-cart-text');
            if (!textEl) return;
            var originalText = textEl.textContent;
            textEl.textContent = window.variantStrings.addedToCart;
            btn.classList.add('added-to-cart');
            setTimeout(function() {
              textEl.textContent = originalText;
              btn.classList.remove('added-to-cart');
            }, 1500);
          }
        });
      });
      observer.observe(btn, { attributes: true, attributeOldValue: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
